module.exports = __webpack_public_path__ + "img/C532.9b4797dc.jpg";